import { useQuery } from "react-query";
import { useSelector } from "react-redux";

import { RootState } from "store/rootReducer";

import { ApiResult } from "../api/apiResult";
import { IpdbSourcePlay, fetchPlayTo3DDataPrivateSources } from "../api/ipdp";

// A prefix: callers invalidate with this alone and the user/org-scoped entries match.
export const PLAY_TO_3D_DATA_PRIVATE_SOURCES_QUERY_KEYS = {
  playTo3DDataPrivateSources: "fetchPlayTo3DDataPrivateSources"
};
///hook to fetch ipdb fields
export default function usePlayTo3DDataPrivateSources(
  enabled = true
): ApiResult<IpdbSourcePlay[]> {
  const user = useSelector((state: RootState) => state.auth.user);
  const userId = user?.id;
  const organizationId = user?.organization?.id ?? user?.organizationId;

  // The answer is per caller, and the QueryClient outlives a logout, so the key
  // carries who asked or the next sign-in inherits the last user's sources.
  const { data, isLoading, isError, refetch } = useQuery<IpdbSourcePlay[]>(
    [
      PLAY_TO_3D_DATA_PRIVATE_SOURCES_QUERY_KEYS.playTo3DDataPrivateSources,
      userId,
      organizationId
    ],
    fetchPlayTo3DDataPrivateSources,
    { enabled: enabled && !!userId && !!organizationId }
  );

  return {
    data,
    isLoading,
    isError,
    refetch
  };
}
